import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { KundenArtsQuerySorterConfig } from 'fa-kt.types';
import { KundenArtsService } from '../service';

@Component({
  selector: 'fa-kt-kunden-arts-sorter',
  templateUrl: './kunden-arts-sorter.component.html',
  styleUrls: ['./kunden-arts-sorter.component.css'],
})
export class KundenArtsSorterComponent {
  KundenArtsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kundenArts: KundenArtsService,
  ) {
    this.KundenArtsSorterConfig = KundenArtsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
